import React, { useState, useEffect, useCallback } from 'react';
import '../../css/spendInsuranceFinal.css';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend, setAssociatedInsuraceList, setCookieId, setSessionId, setAccessToken, setRefreshGastarSaldo } from '../../features/onboardingData/onboardingUserData';
import ProgressBar from 'react-bootstrap/ProgressBar';
import GifIconLoading from '../../assets/gif/mainLoading.gif';
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";
import { FiCheckCircle } from "react-icons/fi";
import IconNotifySuccess from '../../assets/svg/mainIconNotifySuccess.svg';              
import { errorHandling } from '../../utils';
import { AiOutlineStop } from "react-icons/ai";
import moment from 'moment';
import 'moment/locale/pt';

function SpendInsuranceFinal() {

    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const isAccessToken = useSelector((state) => state.onboardingUserData.isAccessToken);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isAssociatedInsuraceList = useSelector((state) => state.onboardingUserData.isAssociatedInsuraceList);
    const isRefreshGastarSaldo = useSelector((state) => state.onboardingUserData.isRefreshGastarSaldo);
    const dispatch = useDispatch();
    const [isStartingLoadingAnim, setIsStartingLoadingAnim] = useState(false)
    const [isProgressFinish, setIsProgressFinish] = useState(false);
    const [progress, setProgress] = useState(0);
    const [progressConfirmAddCardMbWay, setProgressConfirmAddCardMbWay] = useState(0);
    const [startToast, setStartToast] = useState(false);

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(delay);
    }, []);

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const postDeductPremium = async () => {
        setIsStartingLoadingAnim(true);
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/deductPremium/fetchDeductPremium`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'PT-PT',
                    'CookieId': `${isCookieId}`,
                    'SessionId': `${isSessionId}`,
                    "xsrf-token": csrfToken,
                },
                credentials: "include",
                mode: "cors",
                body: JSON.stringify({ 
                    policyNumber: isAssociatedInsuraceList.policyNumber, 
                    deductionValue: isAssociatedInsuraceList.amount.toString(), 
                    nib: isAssociatedInsuraceList.nib.replace(/\s+/g, '').slice(4), 
                    receiptNumber: isAssociatedInsuraceList.receiptNumber, 
                    cardNumber: isAssociatedInsuraceList.cardNumber 
                }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                const intervalId2 = setInterval(() => {
                    setProgressConfirmAddCardMbWay(preProgressConfirmAddCardMbWay => {
                        const newProgressConfirmAddCardMbWay = preProgressConfirmAddCardMbWay + 1;
                        if (newProgressConfirmAddCardMbWay >= 100) {
                            clearInterval(intervalId2);
                            setIsProgressFinish(true);
                            dispatch(setStartSpend(false));
                            dispatch(setRefreshGastarSaldo(!isRefreshGastarSaldo));
                            setStartToast(true);
                        }
                        return newProgressConfirmAddCardMbWay;
                    });
                }, 50);
                return () => clearInterval(intervalId2);
            } else {
                setIsStartingLoadingAnim(false);
                dispatch(setStartSpend(false));
                toast.error("Lamentamos, mas não foi possível processar a sua transferência de saldo. Por favor, tente mais tarde.", {
                    icon: <AiOutlineStop/>
                });
            }
        } catch (error) {
            setIsStartingLoadingAnim(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const hadleFinalize = () => {
        setIsStartingLoadingAnim(true);
        const intervalId2 = setInterval(() => {
            setProgressConfirmAddCardMbWay(preProgressConfirmAddCardMbWay => {
                const newProgressConfirmAddCardMbWay = preProgressConfirmAddCardMbWay + 1;
                if (newProgressConfirmAddCardMbWay >= 100) {
                    clearInterval(intervalId2);
                    setIsProgressFinish(true);
                    dispatch(setStartSpend(false));
                    setStartToast(true);
                }
                return newProgressConfirmAddCardMbWay;
            });
        }, 50);
        return () => clearInterval(intervalId2);
    };

    useEffect(() => {
        if (startToast == true) {
            toast.success("Pedido de transferência de saldo efetuado.", {
                icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
            });
        }
    }, [startToast])

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgress(preProgress => {
                const newProgress = preProgress + 1;
                if (newProgress >= 100) {
                    clearInterval(intervalId);
                }
                return newProgress;
            });
        }, 50);
        return () => clearInterval(intervalId);
    }, [isProgressFinish]);

    const handleBtnClickCancelDeduct = () => {
        dispatch(setStartSpend(false));
    };

    return (
        <>
            {!isStartingLoadingAnim ?
                <>
                    <div className={ isTablet ? 'mainContainer' : ( isMobile ? 'mainContainerTablet' : 'mainContainerMobile')}>
                        <div className={isTablet ? 'secondMainContainerSpendFinal' : (isMobile ? 'secondMainContainerSpendFinalTablet' : 'secondMainContainerSpendFinalMobile')}>
                            <div className='infoTop'>
                                <div className='infoTopContent'>
                                    <div className='textInfoTop'>Valor a transferir para sua conta bancária</div>
                                    <div className='valueInfoTop'>
                                        <div className='txtValueInfoTop'>{isAssociatedInsuraceList.amount}€</div>
                                    </div>
                                    <div className={ isTablet ? 'buttonInfoTop' : 'buttonInfoTopMobile' }>
                                        <CustomButton 
                                            text={'Cancelar'} 
                                            textColor={'#00214D'}
                                            borderColor={'#00214D'}
                                            onPress={handleBtnClickCancelDeduct} 
                                            hasShadow={false}
                                            hasArrow={!isMobile}
                                            iconColor={'#00214D'}
                                        />
                                        <CustomButton
                                            text={'Confirmar transferência'}
                                            textColor={'#FFFFFF'}
                                            onPress={postDeductPremium}
                                            enabled
                                            color={'#E00060'}
                                            hasArrow
                                            iconType={'check'}
                                            iconColor={'#FFFFFF'}
                                        />
                                    </div>
                                </div>
                            </div>
                            { !isTablet &&
                                <div className='deviderLineInsuranceFinal'></div>
                            }
                            <div className='infoBottom'>
                                <div className='infoBottomContent'>
                                    <div className='HInfobottom'>
                                        <div className='text1InfoBottom'>Para onde será feita a transferência?</div>
                                    </div>
                                    <div className='ibanInfoBotton'>
                                        <div className='infoIban'>
                                            <div className='IbanH'>IBAN</div>
                                            <div className='IbanT'>{isAssociatedInsuraceList.nib}</div>
                                        </div>
                                    </div>
                                    { !isTablet &&
                                        <div className='deviderLineInsuranceFinal'></div>
                                    }
                                    <div className='notInfoBotton'>
                                        <div className='textNotInfo'>
                                            <div className='textStartInfo'>
                                                <div className='textDev'>Vamos transferir {isAssociatedInsuraceList.amount}€ para o IBAN indicado</div>
                                                <div className='textDev3'>O valor será transferido até 15 dias úteis após a boa cobrança do recibo do seguro.</div>
                                            </div>
                                        </div>
                                    </div>
                                    { !isTablet &&
                                        <div className='deviderLineInsuranceFinal'></div>
                                    }
                                    <div className={ isTablet ? 'pagamento' : 'pagamentoMobile'}>
                                        <div className='contentPagamento'>
                                            <div className='divText1'>
                                                <div className={ isTablet ? 'rowText' : 'rowTextMobile' }>
                                                    <div className='wrapperText1'>
                                                        <div className='apoliceT'>Seguro</div>
                                                    </div>
                                                    <div className={ isTablet ? 'nCardTView' : 'nCardTViewMobile'}>
                                                        <div  className='nCardTRegular'>Cartão Médis {isAssociatedInsuraceList.cardNumber}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            { !isTablet &&
                                                <div className='deviderLineInsuranceFinal'></div>
                                            }
                                            <div className='divText1'>
                                                <div className={ isTablet ? 'rowText' : 'rowTextMobile' }>
                                                    <div className='wrapperText1'>
                                                        <div className='apoliceT'>Data de pagamento do próximo recibo</div>
                                                    </div>
                                                    <div className={ isTablet ? 'nCardTView' : 'nCardTViewMobile'}>
                                                        <div  className='nCardTRegular'>{moment(isAssociatedInsuraceList.dueDate).format('L')}</div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className={ isTablet ? 'mainContainer' : ( isMobile ? 'mainContainerTablet' : 'mainContainerMobile')}>
                        <div className={isTablet ? 'mainContentViewContainerLinkCardStepMbWaySuccessful' : 'mainContentViewContainerLinkCardStepMbWaySuccessfulMobile'}>
                            <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful'>
                                <div className='titleProgressBarInsuranceFinal'>
                                    <div className={isTablet ? 'mainLoadingTxtTitleBoldLinkCardStepMbWaySuccessful' : 'txtTitleViewContainerLinkCardStepMbWaySuccessfulMobile'}>A processar a transferência</div>
                                    <div className={isTablet ? 'mainLoadingTxtRegularLinkCardStepMbWaySuccessful' : 'txtRegularViewContainerLinkCardStepMbWaySuccessfulMobile'}>Estamos a processar o pedido de transferência de saldo para a sua conta bancária. Aguarde uns segundos.</div>
                                </div>
                            </div>
                            <div className='mainLoadingViewContainerLinkCardStepMbWaySuccessful' style={{ marginTop: '16px' }}>
                                <ProgressBar animated now={progress} className="mainProgressBarViewLinkCardStepMbWaySuccessful" />
                            </div>
                            <div className='manImgViewContainerGifInsuranceFinal'>
                                <img src={GifIconLoading} alt="gif" className='mainGifContainerGifInsuranceFinal' />
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    )
}

export default SpendInsuranceFinal